"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Minio = /*#__PURE__*/ _interop_require_default(require("./Minio"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let MinioPlugin = class MinioPlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return MinioPlugin.storageAdapter;
    }
    async init(config) {
        MinioPlugin.storageAdapter = new _Minio.default(config);
        await MinioPlugin.storageAdapter.init();
    }
};
const _default = MinioPlugin;
